import axios from "axios";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { fetchData } from "../redux/slices/mainDataSlice";
import Can from "../permissions/Can";
import Tooltip from "./Tooltip";

export default function RefillItemButton({ rgmw, style = {}, className = "" }) {
  const dispatch = useDispatch();

  const handleRefill = async () => {
    const credentials = JSON.parse(localStorage.getItem("userCredentials"));
    const token = credentials?.token;

    if (!token) {
      toast.error("مفقود التوكن");
      return;
    }

    try {
      const response = await axios.post(`https://api.alfares.cloud/api/alfares/refillItemNumber/${token}`, { rgmw });
      toast.success(response.data.message || "تم الترتيب بنجاح");
      dispatch(fetchData());
    } catch (error) {
      const message = error.response?.data?.message || error.message || "فشل الترتيب";
      console.error("خطأ في ترتيب الموظفين:", message);
      toast.error(`فشل الترتيب: ${message}`);
    }
  };

  return (
    <Can module="employees" action="edit">
    <Tooltip content="ترتيب اداري">
      <button
        onClick={handleRefill}
        className={`modern-add-btn btn--icon-mobile ${className}`.trim()}
     
        style={{ display: 'flex', alignItems: 'center', gap: '8px', ...style }}
      >
        <i className="fa-solid fa-list-ol"></i>
        <span className="btn-label">ترتيب اداري</span>
      </button>
    </Tooltip>
    </Can>
  );
}
